import { render, staticRenderFns } from "./BulkEditResources.modal.vue?vue&type=template&id=1b914162"
import script from "./BulkEditResources.modal.vue?vue&type=script&lang=ts"
export * from "./BulkEditResources.modal.vue?vue&type=script&lang=ts"
import style0 from "./BulkEditResources.modal.vue?vue&type=style&index=0&id=1b914162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports